/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Cta_H2Inputs */

const es_exp_mk_cta_h2 = /** @type {(inputs: Exp_Mk_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El mar es de quien lo navega.`)
};

const gl_exp_mk_cta_h2 = /** @type {(inputs: Exp_Mk_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O mar é de quen o navega.`)
};

const en_exp_mk_cta_h2 = /** @type {(inputs: Exp_Mk_Cta_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The sea belongs to those who sail it.`)
};

/**
* | output |
* | --- |
* | "The sea belongs to those who sail it." |
*
* @param {Exp_Mk_Cta_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_cta_h2 = /** @type {((inputs?: Exp_Mk_Cta_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Cta_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_cta_h2(inputs)
	if (locale === "en") return en_exp_mk_cta_h2(inputs)
	return es_exp_mk_cta_h2(inputs)
});